<template>
  <div class="home">
    <header class="header">
      <h2>深圳青云智业科技有限公司</h2>
    </header>
    <el-carousel :interval="4000" height="340px">
      <el-carousel-item>
        <img src="../assets/banner.jpg" alt="" srcset="" class="banner-img" />
      </el-carousel-item>
      <!-- <el-carousel-item>
        <img src="../assets/banner2.png" alt="" srcset="" />
      </el-carousel-item> -->
    </el-carousel>
    <div class="desc">
      <h2>关于我们</h2>
      <p class="title">
        深圳青云智业科技有限公司成立于2023-12-29，位于广东省深圳市，所属行业为软件和信息技术服务业。
      </p>
      <div>
        <p>公司主营业务包括:</p>
        <ul>
          <li>
            人工智能行业应用系统集成服务；人工智能硬件销售；人工智能公共数据平台；人工智能通用应用系统；
          </li>
          <li>
            人工智能双创服务平台；人工智能基础软件开发；人工智能基础资源与技术平台；人工智能理论与算法软件开发；
          </li>
          <li>
            人工智能公共服务平台技术咨询服务；人工智能应用软件开发。
          </li>
        </ul>
      </div>
    </div>
    <div class="footer">
      <div class="content">
        <p>
          地址：广东省深圳市龙华区民治街道北站社区龙华区数字创新中心（民治股份商业中心）C栋3810
        </p>
        <p>
          {{
            `Copyright © 2023-${new Date().getFullYear()} qingyunzhiye.com All Rights Reserved.`
          }}
          <a href="https://beian.miit.gov.cn" target="_blank"
            >粤ICP备2026018469 号</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  // name: "Home"
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.logo {
  margin-top: 50px;
}
.footer {
  width: 100%;
  position: fixed;
  bottom: 0;
  line-height: 20px;
  color: #999;
  background: #4b4b4b;
  a {
    text-decoration: none;
    color: #999;
  }
  .content {
    width: 1040px;
    margin: 0 auto;
    text-align: left;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  width: 1040px;
  margin: 0 auto;
}
.desc {
  text-align: left;
  margin: 48px auto;
  width: 1040px;
  h2 {
    border-left: 4px solid #008858;
    padding-left: 8px;
    line-height: 28px;
  }
  .title {
    background-color: #008858;
    color: #fff;
    padding: 10px;
    margin-top: 20px;
    width: 850px;
    background-image: linear-gradient(to right, #008858 0%, #c6f3d7 100%);
  }
}
.banner-img {
  width: 1040px;
  height: 100%;
}
</style>
